import {CheckBoxFormik} from "@src/components/common/CheckBoxFormik/CheckBoxFormik";
import style from '@src/pages/Tours/TourFormalization/components/steps/Step3/Step3.module.scss'
import React, {FC, useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import cn from 'classnames'
import {
    selectCurrentChoosenTourData,
    selectCurrentFreePlaces,
} from "@src/store/ducks/orders/selectors";
import {useFormikContext} from "formik";
import {Place} from "@src/components/AllSvg/Place";
import {Bus49} from "@src/components/AllSvg/Buses/Bus49";
import {Bus51} from "@src/components/AllSvg/Buses/Bus51";
import {Bus53} from "@src/components/AllSvg/Buses/Bus53";

type Step3Props = {
    name: string,
    order:any
}

let arrPlaces: string[] = [];
export const HistoryPreOrderStep3: FC<Step3Props> = ({name, order}) => {
    const svgRef = useRef<any>(null);
    const {getFieldProps, setFieldValue, values}: any = useFormikContext();
    const currentFreePlaces = useSelector(selectCurrentFreePlaces)
    let placesData: any = order.busPlaces
    const currentChoosenTourData = useSelector(selectCurrentChoosenTourData)
    const chosePlace = getFieldProps('data.useFreePlaces').value;
    const scrollRef = useRef<any>();
    const [scrollValue, setScrollValue] = useState(0);
    const [maxValue, setMaxValue] = useState(100); // Начальное значение max
    const [alert, setAlert] = useState(false)
    let currentPlaces = order.places.map((item:any) => {
        return item.place
    })

    const elem = values.data.selectedPlaces

    useEffect(() => {
        const allPlaces = svgRef.current.querySelectorAll('.placeBus');
        allPlaces.forEach((element: any) => {
            element.classList.remove(style.choosen)
            const index = elem.indexOf(element.id);
            if (index > -1) {
                element.classList.add(style.choosen)
            }
        })
    }, [elem])


    useEffect(() => {
        arrPlaces = []
    }, [currentChoosenTourData])


    useEffect(() => {
        if (scrollRef.current) {
            setMaxValue(scrollRef.current.scrollWidth - scrollRef.current.clientWidth)
        }
        scrollRef.current.scrollLeft = scrollValue

    }, [scrollValue])

    const handleScroll = (e: any) => {
        setScrollValue(e.target.value)
    }

    const handleScrollImageWrapper = () => {
        if (scrollRef.current) {
            const scrollValueCurrent = scrollRef.current.scrollLeft;
            setScrollValue(scrollValueCurrent)
            const scrollValueMax = scrollRef.current.scrollWidth - scrollRef.current.clientWidth;
            setMaxValue(scrollValueMax)
        }
    }

    const changeStatus = (e: any) => {
        setAlert(false)
        const activeElem = e.target.closest('g')
        if (!activeElem.classList.contains('busy') && !activeElem.classList.contains('system')) {
            let index = arrPlaces.indexOf(activeElem.id)
            if (index >= 0) {
                arrPlaces.splice(index, 1);
                activeElem.classList.remove(style.choosen)
            } else if (arrPlaces.length < values.data.passengersQuantity) {
                arrPlaces.push(String(activeElem.id));
                activeElem.classList.add(style.choosen)
            }
        }
        setFieldValue(name, arrPlaces)
    }

    useEffect(() => {
        if (svgRef.current) {
            const allPlaces = svgRef.current.querySelectorAll('.placeBus');
            allPlaces.forEach((element: any) => {
                if (placesData) {
                    if (Object.keys(placesData).includes(element.id)) {
                        if (!arrPlaces.includes(element.id)) {
                            if (placesData[element.id] === 'system') {
                                element.classList.add(style.system)
                            } else if (placesData[element.id] === true) {
                                element.classList.add(style.free)
                            } else if (currentPlaces.includes(element.id)) {
                                element.classList.add(style.free)
                            } else {
                                element.classList.add(style.busy)
                            }
                        } else {
                            element.classList.add(style.free)
                        }
                    }
                }
            });
        }
    }, [placesData]);

    useEffect(() => {
        if (chosePlace) {
            setFieldValue(name, []);
        }
    }, [chosePlace]);


    return (
        <div className={style['step-3']}>
            <div className={style.title}>
                <span>Выбор места</span>
            </div>
            <div className={style.subtitle}>Услуга выбора места, является платной и
                составляет {+order.tour.commissionAmountPlace} белорусских рублей.
            </div>
            <CheckBoxFormik
                name="data.useFreePlaces"
                type="checkbox"
                checked={chosePlace}
                label={(
                    <span>
                    Без выбора места
                </span>
                )}
            />
            <div className={cn(style.scheme, chosePlace && style.mask)}>
                <div className={cn(style.schemeWrapper)}>
                    <div ref={scrollRef} className={style.imageWrapper} onScroll={handleScrollImageWrapper}>
                        <div className={style.imageBus}>
                            {order.trip.bus.type === '1' &&
                                <Bus49 ref={svgRef} changeStatus={changeStatus}/>}
                            {order.trip.bus.type === '2' &&
                                <Bus51 ref={svgRef} changeStatus={changeStatus}/>}
                            {order.trip.bus.type === '3' &&
                                <Bus53 ref={svgRef} changeStatus={changeStatus}/>}
                        </div>
                    </div>
                    <div className={style.slidecontainer}>
                        <input type="range"
                               min='0'
                               max={maxValue}
                               value={scrollValue} onChange={handleScroll}/>
                    </div>
                </div>
                <div className={cn(style.customPlaces)}>
                    <div className={style['place-wrapper']}>
                        <div className={cn(style.place, style.colorWhite)}>
                            <Place/>
                        </div>
                        <span>Место свободно</span>
                    </div>
                    <div className={style['place-wrapper']}>
                        <div className={cn(style.place, style.colorRed)}>
                            <Place/>
                        </div>
                        <span>Место занято</span>
                    </div>
                    <div className={style['place-wrapper']}>
                        <div className={cn(style.place, style.colorGray)}>
                            <Place/>
                        </div>
                        <span>Служебное место</span>
                    </div>
                    <div className={style['place-wrapper']}>
                        <div className={cn(style.place, style.colorBlue)}>
                            <Place/>
                        </div>
                        <span>Место выбрано вами</span>
                    </div>
                </div>
            </div>
            {alert && <div className={style.alert}> Заполните все места согласно количеству билетов</div>}
            <div className={cn(style.info, chosePlace && style.mask)}>
                <p>Типовая схема* расположения мест в автобусе</p>
                <p>*Расположение кресел и дверей в автобусе указано примерно и может отличаться в зависимости от модели,
                    марки автобуса и общего количества посадочных мест.</p>
            </div>
        </div>
    )
}
